import { render, staticRenderFns } from "./LpModal.vue?vue&type=template&id=fb8971f8&scoped=true"
import script from "./LpModal.vue?vue&type=script&lang=js"
export * from "./LpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8971f8",
  null
  
)

export default component.exports